
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "DCOLPIC",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DCOLPIC.vue